import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 获取离线回复语
export function webGetAutomaticReply(friend_id,callback){
	request({
			method: 'post',
			url: 'AutomaticReply/getAutomaticReplyOutLine',
			data: {
				manager_id:getLoginId(),
				friend_id: friend_id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 修改群信息
export function webSaveInfo(param,callback){
	request({
			method: 'post',
			url: 'cluster/save',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 修改群信息
export function webCreateCluster(param,callback){
	request({
			method: 'post',
			url: 'cluster/createCluster',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 删除群信息
export function webDeleteCluster(clusterId,callback){
	request({
			method: 'post',
			url: 'cluster/deleteCluster',
			data: {
				clusterId:clusterId
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}